import { makeError } from 'ethers';
export async function executeTx(contractTxPromise) {
    const tx = await contractTxPromise;
    return new Promise((resolve, reject) => {
        // reject when the provider is destroyed
        const cancel = detectProviderDestroyed(tx.provider, reject);
        tx.wait().then(resolve, reject).finally(cancel);
    });
}
const detectProviderDestroyed = (provider, reject) => {
    const onProviderDestroy = (eventData) => {
        const action = eventData?.action ?? '';
        if (action !== 'destroy')
            return;
        provider.off('debug', onProviderDestroy);
        reject(makeError('provider is destroyed when switching network', 'ACTION_REJECTED', {
            action: 'sendTransaction',
            reason: 'rejected',
        }));
    };
    provider.on('debug', onProviderDestroy);
    return () => {
        provider.off('debug', onProviderDestroy);
    };
};
